import React from "react";

import Ultimate from "../Garments//UltimateTrousers/UltimateFront";
import UltimateBack from "../Garments/UltimateTrousers/UltimateBack";
import Dynamix from "../Garments/Dynamix/DynamixFront";
import DynamixBack from "../Garments/Dynamix/DynamixBack";
import ParkaPrimoAussenjackeFront from "../Garments/ParkaPrimoAussenjacke/ParkaPrimoAussenjackeFront";
import ParkaPrimoAussenjackeBack from "../Garments/ParkaPrimoAussenjacke/ParkaPrimoAussenjackeBack";
import ParkaPrimoInnenjackeFront from "../Garments/ParkaPrimoInnenjacke/ParkaPrimoInnenjackeFront";
import ParkaPrimoInnenjackeBack from "../Garments/ParkaPrimoInnenjacke/ParkaPrimoInnenjackeBack";
import TrendFront from "../Garments/Trend/TrendFront";
import TrendBack from "../Garments/Trend/TrendBack";
import OpticaFront from "../Garments/OpticaHose/OpticaFront";
import OpticaBack from "../Garments/OpticaHose/OpticaBack";
import PolarFront from "../Garments/Polar/PolarFront";
import PolarBack from "../Garments/Polar/PolarBack";

import {COLORS} from "./colors";
import {PRICE} from "./prices";
import GiletPrimoRVBack from "../Garments/GiletPrimoRV/GiletPrimoRVBack";
import GiletPrimoRVFront from "../Garments/GiletPrimoRV/GiletPrimoRVFront";
import ClassicoShortsFront from "../Garments/ClassicoShorts/ClassicoShortsFront";
import ClassicoShortsBack from "../Garments/ClassicoShorts/ClassicoShortsFront";
import GiletPrimoKnopfenFront from "../Garments/GilletPrimoKnopfen/GilletPrimoKnopfenFront";
import GiletPrimoKnopfenBack from "../Garments/GilletPrimoKnopfen/GilletPrimoKnopfenBack";
import ClassicoHoseFront from "../Garments/ClassicoHose/ClassicoHoseFront";
import ClassicoHoseBack from "../Garments/ClassicoHose/ClassicoHoseBack";
import SoftshelljackePrimoPlusFront from "../Garments/SoftshelljackePrimoPlus/SoftshelljackePrimoPlusFront";
import SoftshelljackePrimoPlusBack from "../Garments/SoftshelljackePrimoPlus/SoftshelljackePrimoPlusBack";
import SoftshelljackePrimoFront from "../Garments/SoftshelljackePrimo/SoftshelljackePrimoFront";
import SoftshelljackePrimoBack from "../Garments/SoftshelljackePrimo/SoftshelljackePrimoBack";
import DamenkasackPrimoFront from "../Garments/DamenkasackPrimo/DamenkasackPrimoFront";
import DamenkasackPrimoBack from "../Garments/DamenkasackPrimo/DamenkasackPrimoBack";
import TrendGiletFront from "../Garments/TrendGilet/TrendGiletFront";
import TrendGiletBack from "../Garments/TrendGilet/TrendGiletBack";
import ClassicoJackeFront from "../Garments/ClassicoJacke/ClassicoJackeFront";
import ClassicoJackeBack from "../Garments/ClassicoJacke/ClassicoJackeBack";
import FleecejackePrimoFront from "../Garments/FleecejackePrimo/FleecejackePrimoFront";
import FleecejackePrimoBack from "../Garments/FleecejackePrimo/FleecejackePrimoBack";
import BerufsmantelPrimoFront from "../Garments/BerufsmantelPrimo/BerufsmantelPrimoFront";
import BerufsmantelPrimoBack from "../Garments/BerufsmantelPrimo/BerufsmantelPrimoFront";
import LatzhosePrimoFront from "../Garments/LatzhosePrimo/LatzhosePrimoFront";
import LatzhosePrimoBack from "../Garments/LatzhosePrimo/LatzhosePrimoBack";
import OverallPrimoFront from "../Garments/OverallPrimo/OverallPrimoFront";
import OverallPrimoBack from "../Garments/OverallPrimo/OverallPrimoBack";

const defaultGarmentProps = (printStyle, item) => {
  return {
    lightContrast: item.lightContrast,
    darkContrast: item.darkContrast,
    stitching: item.stitching,
    patchColor: item.patchColor,
    azomo: item.azomo,
    printStyle: printStyle,
    preview: true,
  };
};

const renderCartItem = (printStyle, item) => {
  try {
    switch (item.name) {
      case "ultimate":
        return (
          <div>
            {React.createElement(Ultimate, defaultGarmentProps(printStyle, item))}
            {React.createElement(UltimateBack, defaultGarmentProps(printStyle, item))}
          </div>
        );
      case "dynamix":
        return (
          <div>
            {React.createElement(Dynamix, defaultGarmentProps(printStyle, item))}
            {React.createElement(DynamixBack, defaultGarmentProps(printStyle, item))}
          </div>
        );
      case "parkaprimoaussenjacke":
        return (
          <div>
            {React.createElement(
              ParkaPrimoAussenjackeFront,
              defaultGarmentProps(printStyle, item)
            )}
            {React.createElement(
              ParkaPrimoAussenjackeBack,
              defaultGarmentProps(printStyle, item)
            )}
          </div>
        );
      case "parkaprimoinnenjacke":
        return (
          <div>
            {React.createElement(
              ParkaPrimoInnenjackeFront,
              defaultGarmentProps(printStyle, item)
            )}
            {React.createElement(
              ParkaPrimoInnenjackeBack,
              defaultGarmentProps(printStyle, item)
            )}
          </div>
        );
      case "trend":
        return (
          <div>
            {React.createElement(TrendFront, defaultGarmentProps(printStyle, item))}
            {React.createElement(TrendBack, defaultGarmentProps(printStyle, item))}
          </div>
        );
      case "optica":
        return (
          <div>
            {React.createElement(OpticaFront, defaultGarmentProps(printStyle, item))}
            {React.createElement(OpticaBack, defaultGarmentProps(printStyle, item))}
          </div>
        );
      case "polar":
        return (
          <div>
            {React.createElement(PolarFront, defaultGarmentProps(printStyle, item))}
            {React.createElement(PolarBack, defaultGarmentProps(printStyle, item))}
          </div>
        );
      case "damenkasack":
        return (
          <div>
            {React.createElement(
              DamenkasackPrimoFront,
              defaultGarmentProps(printStyle, item)
            )}
            {React.createElement(
              DamenkasackPrimoBack,
              defaultGarmentProps(printStyle, item)
            )}
          </div>
        );
      case "classicoshorts":
        return (
          <div>
            {React.createElement(
              ClassicoShortsFront,
              defaultGarmentProps(printStyle, item)
            )}
            {React.createElement(
              ClassicoShortsBack,
              defaultGarmentProps(printStyle, item)
            )}
          </div>
        );
      case "giletprimorv":
        return (
          <div>
            {React.createElement(
              GiletPrimoRVFront,
              defaultGarmentProps(printStyle, item)
            )}
            {React.createElement(GiletPrimoRVBack, defaultGarmentProps(printStyle, item))}
          </div>
        );
      case "gilletprimoknopfen":
        return (
          <div>
            {React.createElement(
              GiletPrimoKnopfenFront,
              defaultGarmentProps(printStyle, item)
            )}
            {React.createElement(
              GiletPrimoKnopfenBack,
              defaultGarmentProps(printStyle, item)
            )}
          </div>
        );
      case "classicohose":
        return (
          <div>
            {React.createElement(
              ClassicoHoseFront,
              defaultGarmentProps(printStyle, item)
            )}
            {React.createElement(ClassicoHoseBack, defaultGarmentProps(printStyle, item))}
          </div>
        );
      case "softshelljackeprimoplus":
        return (
          <div>
            {React.createElement(
              SoftshelljackePrimoPlusFront,
              defaultGarmentProps(printStyle, item)
            )}
            {React.createElement(
              SoftshelljackePrimoPlusBack,
              defaultGarmentProps(printStyle, item)
            )}
          </div>
        );
      case "trendgilet":
        return (
          <div>
            {React.createElement(TrendGiletFront, defaultGarmentProps(printStyle, item))}
            {React.createElement(TrendGiletBack, defaultGarmentProps(printStyle, item))}
          </div>
        );
      case "classicojacke":
        return (
          <div>
            {React.createElement(
              ClassicoJackeFront,
              defaultGarmentProps(printStyle, item)
            )}
            {React.createElement(
              ClassicoJackeBack,
              defaultGarmentProps(printStyle, item)
            )}
          </div>
        );
      case "fleecejackeprimo":
        return (
          <div>
            {React.createElement(
              FleecejackePrimoFront,
              defaultGarmentProps(printStyle, item)
            )}
            {React.createElement(
              FleecejackePrimoBack,
              defaultGarmentProps(printStyle, item)
            )}
          </div>
        );
      case "berufsmantelprimo":
        return (
          <div>
            {React.createElement(
              BerufsmantelPrimoFront,
              defaultGarmentProps(printStyle, item)
            )}
            {React.createElement(
              BerufsmantelPrimoBack,
              defaultGarmentProps(printStyle, item)
            )}
          </div>
        );
      case "softshelljackeprimo":
        return (
          <div>
            {React.createElement(
              SoftshelljackePrimoFront,
              defaultGarmentProps(printStyle, item)
            )}
            {React.createElement(
              SoftshelljackePrimoBack,
              defaultGarmentProps(printStyle, item)
            )}
          </div>
        );
      case "overallprimo":
        return (
          <div>
            {React.createElement(
              OverallPrimoFront,
              defaultGarmentProps(printStyle, item)
            )}
            {React.createElement(OverallPrimoBack, defaultGarmentProps(printStyle, item))}
          </div>
        );
      case "latzhoseprimo":
        return (
          <div>
            {React.createElement(
              LatzhosePrimoFront,
              defaultGarmentProps(printStyle, item)
            )}
            {React.createElement(
              LatzhosePrimoBack,
              defaultGarmentProps(printStyle, item)
            )}
          </div>
        );

      default:
        return <p>ERROR</p>;
    }
  } catch (error) {}
};

const generateParam = (item, type) => {
  let param = type;

  switch (item.lightContrast) {
    case COLORS.white ? COLORS.white.value : "a":
      param = param + "a";
      break;
    case COLORS.black ? COLORS.black.value : "a":
      param = param + "b";
      break;
    case COLORS.paleGrey ? COLORS.paleGrey.value : "a":
      param = param + "c";
      break;
    case COLORS.moleGrey ? COLORS.moleGrey.value : "a":
      param = param + "d";
      break;
    case COLORS.convoyGrey ? COLORS.convoyGrey.value : "a":
      param = param + "e";
      break;
    case COLORS.kellyGreen ? COLORS.kellyGreen.value : "a":
      param = param + "f";
      break;
    case COLORS.royalBox ? COLORS.royalBox.value : "a":
      param = param + "g";
      break;
    case COLORS.marine ? COLORS.marine.value : "a":
      param = param + "h";
      break;

    //old colors
    case COLORS.gray ? COLORS.gray.value : "a":
      param = param + "i";
      break;
    case COLORS.darkBlue ? COLORS.darkBlue.value : "a":
      param = param + "j";
      break;
    case COLORS.lightBlue ? COLORS.lightBlue.value : "a":
      param = param + "k";
      break;
    case COLORS.red ? COLORS.red.value : "a":
      param = param + "l";
      break;
    case COLORS.green ? COLORS.green.value : "a":
      param = param + "m";
      break;
    case COLORS.brown ? COLORS.brown.value : "a":
      param = param + "n";
      break;
    case COLORS.whiteProtective ? COLORS.whiteProtective.value : "a":
      param = param + "o";
      break;
    case COLORS.blackProtective ? COLORS.blackProtective.value : "a":
      param = param + "p";
      break;
    case COLORS.grayProtective ? COLORS.grayProtective.value : "a":
      param = param + "q";
      break;

    default:
      break;
  }

  switch (item.darkContrast) {
    case COLORS.white ? COLORS.white.value : "a":
      param = param + "a";
      break;
    case COLORS.black ? COLORS.black.value : "a":
      param = param + "b";
      break;
    case COLORS.paleGrey ? COLORS.paleGrey.value : "a":
      param = param + "c";
      break;
    case COLORS.moleGrey ? COLORS.moleGrey.value : "a":
      param = param + "d";
      break;
    case COLORS.convoyGrey ? COLORS.convoyGrey.value : "a":
      param = param + "e";
      break;
    case COLORS.kellyGreen ? COLORS.kellyGreen.value : "a":
      param = param + "f";
      break;
    case COLORS.royalBox ? COLORS.royalBox.value : "a":
      param = param + "g";
      break;
    case COLORS.marine ? COLORS.marine.value : "a":
      param = param + "h";
      break;

    //old colors
    case COLORS.gray ? COLORS.gray.value : "a":
      param = param + "i";
      break;
    case COLORS.darkBlue ? COLORS.darkBlue.value : "a":
      param = param + "j";
      break;
    case COLORS.lightBlue ? COLORS.lightBlue.value : "a":
      param = param + "k";
      break;
    case COLORS.red ? COLORS.red.value : "a":
      param = param + "l";
      break;
    case COLORS.green ? COLORS.green.value : "a":
      param = param + "m";
      break;
    case COLORS.brown ? COLORS.brown.value : "a":
      param = param + "n";
      break;
    case COLORS.whiteProtective ? COLORS.whiteProtective.value : "a":
      param = param + "o";
      break;
    case COLORS.blackProtective ? COLORS.blackProtective.value : "a":
      param = param + "p";
      break;
    case COLORS.grayProtective ? COLORS.grayProtective.value : "a":
      param = param + "q";
      break;

    default:
      break;
  }

  switch (item.stitching) {
    case COLORS.white ? COLORS.white.value : "a":
      param = param + "a";
      break;
    case COLORS.black ? COLORS.black.value : "a":
      param = param + "b";
      break;
    case COLORS.paleGrey ? COLORS.paleGrey.value : "a":
      param = param + "c";
      break;
    case COLORS.moleGrey ? COLORS.moleGrey.value : "a":
      param = param + "d";
      break;
    case COLORS.convoyGrey ? COLORS.convoyGrey.value : "a":
      param = param + "e";
      break;
    case COLORS.kellyGreen ? COLORS.kellyGreen.value : "a":
      param = param + "f";
      break;
    case COLORS.royalBox ? COLORS.royalBox.value : "a":
      param = param + "g";
      break;
    case COLORS.marine ? COLORS.marine.value : "a":
      param = param + "h";
      break;

    //old colors
    case COLORS.gray ? COLORS.gray.value : "a":
      param = param + "i";
      break;
    case COLORS.darkBlue ? COLORS.darkBlue.value : "a":
      param = param + "j";
      break;
    case COLORS.lightBlue ? COLORS.lightBlue.value : "a":
      param = param + "k";
      break;
    case COLORS.red ? COLORS.red.value : "a":
      param = param + "l";
      break;
    case COLORS.green ? COLORS.green.value : "a":
      param = param + "m";
      break;
    case COLORS.brown ? COLORS.brown.value : "a":
      param = param + "n";
      break;
    case COLORS.whiteProtective ? COLORS.whiteProtective.value : "a":
      param = param + "o";
      break;
    case COLORS.blackProtective ? COLORS.blackProtective.value : "a":
      param = param + "p";
      break;
    case COLORS.grayProtective ? COLORS.grayProtective.value : "a":
      param = param + "q";
      break;

    default:
      break;
  }

  switch (item.patchColor) {
    case COLORS.white ? COLORS.white.value : "a":
      param = param + "a";
      break;
    case COLORS.black ? COLORS.black.value : "a":
      param = param + "b";
      break;
    case COLORS.paleGrey ? COLORS.paleGrey.value : "a":
      param = param + "c";
      break;
    case COLORS.moleGrey ? COLORS.moleGrey.value : "a":
      param = param + "d";
      break;
    case COLORS.convoyGrey ? COLORS.convoyGrey.value : "a":
      param = param + "e";
      break;
    case COLORS.kellyGreen ? COLORS.kellyGreen.value : "a":
      param = param + "f";
      break;
    case COLORS.royalBox ? COLORS.royalBox.value : "a":
      param = param + "g";
      break;
    case COLORS.marine ? COLORS.marine.value : "a":
      param = param + "h";
      break;

    //old colors
    case COLORS.gray ? COLORS.gray.value : "a":
      param = param + "i";
      break;
    case COLORS.darkBlue ? COLORS.darkBlue.value : "a":
      param = param + "j";
      break;
    case COLORS.lightBlue ? COLORS.lightBlue.value : "a":
      param = param + "k";
      break;
    case COLORS.red ? COLORS.red.value : "a":
      param = param + "l";
      break;
    case COLORS.green ? COLORS.green.value : "a":
      param = param + "m";
      break;
    case COLORS.brown ? COLORS.brown.value : "a":
      param = param + "n";
      break;
    case COLORS.whiteProtective ? COLORS.whiteProtective.value : "a":
      param = param + "o";
      break;
    case COLORS.blackProtective ? COLORS.blackProtective.value : "a":
      param = param + "p";
      break;
    case COLORS.grayProtective ? COLORS.grayProtective.value : "a":
      param = param + "q";
      break;

    default:
      break;
  }

  switch (item.azomo) {
    case COLORS.white ? COLORS.white.value : "a":
      param = param + "a";
      break;
    case COLORS.black ? COLORS.black.value : "a":
      param = param + "b";
      break;
    case COLORS.paleGrey ? COLORS.paleGrey.value : "a":
      param = param + "c";
      break;
    case COLORS.moleGrey ? COLORS.moleGrey.value : "a":
      param = param + "d";
      break;
    case COLORS.convoyGrey ? COLORS.convoyGrey.value : "a":
      param = param + "e";
      break;
    case COLORS.kellyGreen ? COLORS.kellyGreen.value : "a":
      param = param + "f";
      break;
    case COLORS.royalBox ? COLORS.royalBox.value : "a":
      param = param + "g";
      break;
    case COLORS.marine ? COLORS.marine.value : "a":
      param = param + "h";
      break;

    //old colors
    case COLORS.gray ? COLORS.gray.value : "a":
      param = param + "i";
      break;
    case COLORS.darkBlue ? COLORS.darkBlue.value : "a":
      param = param + "j";
      break;
    case COLORS.lightBlue ? COLORS.lightBlue.value : "a":
      param = param + "k";
      break;
    case COLORS.red ? COLORS.red.value : "a":
      param = param + "l";
      break;
    case COLORS.green ? COLORS.green.value : "a":
      param = param + "m";
      break;
    case COLORS.brown ? COLORS.brown.value : "a":
      param = param + "n";
      break;
    case COLORS.whiteProtective ? COLORS.whiteProtective.value : "a":
      param = param + "o";
      break;
    case COLORS.blackProtective ? COLORS.blackProtective.value : "a":
      param = param + "p";
      break;
    case COLORS.grayProtective ? COLORS.grayProtective.value : "a":
      param = param + "q";
      break;

    default:
      break;
  }

  param = param + "@";

  item.extraOptions.map((option) => {
    switch (option) {
      case "Rechte Multifunktionstasche":
        param = param + "a";
        break;
      case "Leuchtstreifen an den Beinen":
        param = param + "b";
        break;
      case "Stickerei auf Beintasche links":
        param = param + "c";
        break;
      case "Stickerei auf Geässtsache links":
        param = param + "d";
        break;
      case "Stickerei auf Brusttasche":
        param = param + "e";
        break;
      case "Rechtes Oberschenkel-Logo":
        param = param + "f";
        break;
      case "Logo auf der Vorderseite":
        param = param + "g";
        break;
      case "Logo auf der Rückseite":
        param = param + "h";
        break;
      case "Brusttasche Links":
        param = param + "j";
        break;
      case "Material: Softshell":
        param = param + "k";
        break;
      case "Material: Mischgewebe":
        param = param + "l";
        break;
      case "Material: Baumwolle verstärkt":
        param = param + "m";
        break;
      case "Material: Sotina":
        param = param + "n";
        break;
      case "Material: Sotina Plus":
        param = param + "o";
        break;
      case "Material: Polar Fleece 280":
        param = param + "p";
        break;
      case "Material: Polar Fleece 230":
        param = param + "r";
        break;
      case "Material: Escelade":
        param = param + "s";
        break;
      case "Material: Ripstop":
        param = param + "t";
        break;
      case "Stickerei auf Brusttasche links":
        param = param + "u";
        break;
      case "Cordura":
        param = param + "v";
        break;

      default:
        break;
    }

    return param;
  });

  param = param + "@" + item.quantity;

  return param;
};

const renderColor = (code) => {
  switch (code) {
    case COLORS.white ? COLORS.white.value : COLORS.white.value:
      return (
        <span>
          <svg width="20" height="15">
            <rect stroke="black" fill={code} width="15" height="15" />
          </svg>
          {COLORS.white.label ? COLORS.white.label : "Unknown color."}
        </span>
      );

    case COLORS.black ? COLORS.black.value : COLORS.white.value:
      return (
        <span>
          <svg width="20" height="15">
            <rect stroke="black" fill={code} width="15" height="15" />
          </svg>
          {COLORS.black.label ? COLORS.black.label : "Unknown color."}
        </span>
      );

    case COLORS.gray ? COLORS.gray.value : COLORS.white.value:
      return (
        <span>
          <svg width="20" height="15">
            <rect stroke="black" fill={code} width="15" height="15" />
          </svg>
          {COLORS.gray.label ? COLORS.gray.label : "Unknown color."}
        </span>
      );

    case COLORS.darkBlue ? COLORS.darkBlue.value : COLORS.white.value:
      return (
        <span>
          <svg width="20" height="15">
            <rect stroke="black" fill={code} width="15" height="15" />
          </svg>
          {COLORS.darkBlue.label ? COLORS.darkBlue.label : "Unknown color."}
        </span>
      );

    case COLORS.lightBlue ? COLORS.lightBlue.value : COLORS.white.value:
      return (
        <span>
          <svg width="20" height="15">
            <rect stroke="black" fill={code} width="15" height="15" />
          </svg>
          {COLORS.lightBlue.label ? COLORS.lightBlue.label : "Unknown color."}
        </span>
      );

    case COLORS.red ? COLORS.red.value : COLORS.white.value:
      return (
        <span>
          <svg width="20" height="15">
            <rect stroke="black" fill={code} width="15" height="15" />
          </svg>
          {COLORS.red.label ? COLORS.red.label : "Unknown color."}
        </span>
      );

    case COLORS.green ? COLORS.green.value : COLORS.white.value:
      return (
        <span>
          <svg width="20" height="15">
            <rect stroke="black" fill={code} width="15" height="15" />
          </svg>
          {COLORS.green.label ? COLORS.green.label : "Unknown color."}
        </span>
      );

    case COLORS.brown ? COLORS.brown.value : COLORS.white.value:
      return (
        <span>
          <svg width="20" height="15">
            <rect stroke="black" fill={code} width="15" height="15" />
          </svg>
          {COLORS.brown.label ? COLORS.brown.label : "Unknown color."}
        </span>
      );

    case COLORS.whiteProtective ? COLORS.whiteProtective.value : COLORS.white.value:
      return (
        <span>
          <svg width="20" height="15">
            <rect stroke="black" fill={code} width="15" height="15" />
          </svg>
          {COLORS.whiteProtective.label ? COLORS.whiteProtective.label : "Unknown color."}
        </span>
      );

    case COLORS.blackProtective ? COLORS.blackProtective.value : COLORS.white.value:
      return (
        <span>
          <svg width="20" height="15">
            <rect stroke="black" fill={code} width="15" height="15" />
          </svg>
          {COLORS.blackProtective.label ? COLORS.blackProtective.label : "Unknown color."}
        </span>
      );

    case COLORS.grayProtective ? COLORS.grayProtective.value : COLORS.white.value:
      return (
        <span>
          <svg width="20" height="15">
            <rect stroke="black" fill={code} width="15" height="15" />
          </svg>
          {COLORS.grayProtective.label ? COLORS.grayProtective.label : "Unknown color."}
        </span>
      );

    case COLORS.paleGrey ? COLORS.paleGrey.value : COLORS.white.value:
      return (
        <span>
          <svg width="20" height="15">
            <rect stroke="black" fill={code} width="15" height="15" />
          </svg>
          {COLORS.paleGrey.label ? COLORS.paleGrey.label : "Unknown color."}
        </span>
      );

    case COLORS.moleGrey ? COLORS.moleGrey.value : COLORS.white.value:
      return (
        <span>
          <svg width="20" height="15">
            <rect stroke="black" fill={code} width="15" height="15" />
          </svg>
          {COLORS.moleGrey.label ? COLORS.moleGrey.label : "Unknown color."}
        </span>
      );

    case COLORS.convoyGrey ? COLORS.convoyGrey.value : COLORS.white.value:
      return (
        <span>
          <svg width="20" height="15">
            <rect stroke="black" fill={code} width="15" height="15" />
          </svg>
          {COLORS.convoyGrey.label ? COLORS.convoyGrey.label : "Unknown color."}
        </span>
      );

    case COLORS.kellyGreen ? COLORS.kellyGreen.value : COLORS.white.value:
      return (
        <span>
          <svg width="20" height="15">
            <rect stroke="black" fill={code} width="15" height="15" />
          </svg>
          {COLORS.kellyGreen.label ? COLORS.kellyGreen.label : "Unknown color."}
        </span>
      );

    case COLORS.royalBox ? COLORS.royalBox.value : COLORS.white.value:
      return (
        <span>
          <svg width="20" height="15">
            <rect stroke="black" fill={code} width="15" height="15" />
          </svg>
          {COLORS.royalBox.label ? COLORS.royalBox.label : "Unknown color."}
        </span>
      );

    case COLORS.marine ? COLORS.marine.value : COLORS.white.value:
      return (
        <span>
          <svg width="20" height="15">
            <rect stroke="black" fill={code} width="15" height="15" />
          </svg>
          {COLORS.marine.label ? COLORS.marine.label : "Unknown color."}
        </span>
      );

    default:
      break;
  }
};

const generateUrlForClipboard = (items) => {
  const params = items.map((item) => {
    switch (item.name) {
      case "ultimate":
        return generateParam(item, "ut@");
      case "dynamix":
        return generateParam(item, "dy@");
      case "parkaprimoaussenjacke":
        return generateParam(item, "ppa@");
      case "parkaprimoinnenjacke":
        return generateParam(item, "ppi@");
      case "trend":
        return generateParam(item, "tr@");
      case "optica":
        return generateParam(item, "op@");
      case "polar":
        return generateParam(item, "po@");
      case "damenkasack":
        return generateParam(item, "dk@");
      case "giletprimorv":
        return generateParam(item, "gprv@");
      case "classicoshorts":
        return generateParam(item, "cs@");
      case "classicohose":
        return generateParam(item, "ch@");
      case "softshelljackeprimoplus":
        return generateParam(item, "sjp@");
      case "gilletprimoknopfen":
        return generateParam(item, "gpk@");
      case "trendgilet":
        return generateParam(item, "tg@");
      case "classicojacke":
        return generateParam(item, "cj@");
      case "fleecejackeprimo":
        return generateParam(item, "fjp@");
      case "berufsmantelprimo":
        return generateParam(item, "bmp@");
      case "softshelljackeprimo":
        return generateParam(item, "sj@");
      case "overallprimo":
        return generateParam(item, "ov@");
      case "latzhoseprimo":
        return generateParam(item, "lp@");

      default:
        return "Bad item!";
    }
  });
  let url = "shared?selection=";

  params.map((param) => {
    url = url + param + "+";
    return url;
  });
  return url.slice(0, -1);
};

const convertToColors = (dataList) => {
  const colors = dataList.map((item) => {
    switch (item) {
      case "a":
        return COLORS.white.value;
      case "b":
        return COLORS.black.value;
      case "c":
        return COLORS.paleGrey.value;
      case "d":
        return COLORS.moleGrey.value;
      case "e":
        return COLORS.convoyGrey.value;
      case "f":
        return COLORS.kellyGreen.value;
      case "g":
        return COLORS.royalBox.value;
      case "h":
        return COLORS.marine.value;
      case "i":
        return COLORS.gray.value;
      case "j":
        return COLORS.darkBlue.value;
      case "k":
        return COLORS.lightBlue.value;
      case "l":
        return COLORS.red.value;
      case "m":
        return COLORS.green.value;
      case "n":
        return COLORS.brown.value;
      case "o":
        return COLORS.whiteProtective.value;
      case "p":
        return COLORS.blackProtective.value;
      case "q":
        return COLORS.grayProtective.value;

      default:
        return undefined;
    }
  });

  return colors;
};

const convertToOptions = (dataList) => {
  const options = dataList.map((item) => {
    switch (item) {
      case "a":
        return "Rechte Multifunktionstasche";
      case "b":
        return "Leuchtstreifen an den Beinen";
      case "c":
        return "Stickerei auf Beintasche links";
      case "d":
        return "Stickerei auf Geässtsache links";
      case "e":
        return "Stickerei auf Brusttasche";
      case "f":
        return "Rechtes Oberschenkel-Logo";
      case "g":
        return "Logo auf der Vorderseite";
      case "h":
        return "Logo auf der Rückseite";
      case "j":
        return "Brusttasche Links";
      case "k":
        return "Material: Softshell";
      case "l":
        return "Material: Mischgewebe";
      case "m":
        return "Material: Baumwolle verstärkt";
      case "n":
        return "Material: Sotina";
      case "o":
        return "Material: Sotina Plus";
      case "p":
        return "Material: Polar Fleece 280";
      case "r":
        return "Material: Polar Fleece 230";
      case "s":
        return "Material: Escelade";
      case "t":
        return "Material: Ripstop";
      case "u":
        return "Stickerei auf Brusttasche links";
      case "v":
        return "Cordura";

      default:
        return undefined;
    }
  });

  return options;
};

const convertToComponent = (dataList) => {
  let items = dataList.map((item) => {
    let data = item.split("@");
    switch (data[0]) {
      case "ut":
        return convertToUltimateTrousers(data);
      case "dy":
        return convertToDynamixTrousers(data);
      case "ppa":
        return convertToParkaPrimoAussenjacke(data);
      case "ppi":
        return convertToParkaPrimoInnenjacke(data);
      case "tr":
        return convertToTrend(data);
      case "op":
        return convertToOpticaHose(data);
      case "po":
        return convertToPolar(data);
      case "dk":
        return convertToDamenkasackPrimo(data);
      case "gprv":
        return convertToGiletPrimoRV(data);
      case "cs":
        return convertToClassicoShorts(data);
      case "ch":
        return convertToClassicoHose(data);
      case "gpk":
        return convertToGilletPrimoKnopfen(data);
      case "sjp":
        return convertToSoftshelljackePlus(data);
      case "tg":
        return convertToTrendGilet(data);
      case "cj":
        return convertToClassicoJacke(data);
      case "fjp":
        return convertToFleecejackePrimo(data);
      case "bmp":
        return convertToBerufsmantelPrimo(data);
      case "sj":
        return convertToSoftshelljacke(data);
      case "ov":
        return convertToOverallPrimo(data);
      case "lp":
        return convertToLatzhosePrimo(data);

      default:
        items = null;
        return null;
    }
  });

  return items;
};

const convertToUltimateTrousers = (item) => {
  let ultimate = {
    name: "ultimate",
    garmentName: "Hose Ultimate",
    extraOptions: [],
    lightContrast: "",
    darkContrast: "",
    stitching: "",
    patchColor: "",
    azomo: "",
    price: PRICE.ultimatetrousers,
    quantity: 0,
    totalPrice: 0,
    hasPatch: true,
    hasContrast: true,
  };

  let colors = [...item[1]];

  if (colors.length < 5) {
    return "Bad url!";
  }
  colors = convertToColors(colors);
  ultimate.lightContrast = colors[0];
  ultimate.darkContrast = colors[1];
  ultimate.stitching = colors[2];
  ultimate.patchColor = colors[3];
  ultimate.azomo = colors[4];

  const optionsList = [...item[2]];
  ultimate.extraOptions = convertToOptions(optionsList);

  ultimate.extraOptions.map((i) => {
    switch (i) {
      case "Leuchtstreifen an den Beinen":
        return (ultimate.price = ultimate.price + PRICE.reflectivestrips);
      case "Stickerei auf Beintasche links":
        return (ultimate.price = ultimate.price + PRICE.logo);
      case "Stickerei auf Geässtsache links":
        return (ultimate.price = ultimate.price + PRICE.logo);
      case "Material: Ripstop":
        return (ultimate.price = ultimate.price + PRICE.ripstop);
      case "Material: Escelade":
        return (ultimate.price = ultimate.price + PRICE.escelade);

      default:
        return null;
    }
  });

  if (
    ultimate.patchColor === COLORS.blackProtective.value ||
    ultimate.patchColor === COLORS.whiteProtective.value ||
    ultimate.patchColor === COLORS.grayProtective.value
  ) {
    ultimate.price += PRICE.cordura;
    console.log("DODATO");
  }
  console.log(ultimate.price);
  ultimate.quantity = parseInt(item[3]);
  ultimate.totalPrice = parseInt(item[3]) * ultimate.price;

  return ultimate;
};

const convertToDynamixTrousers = (item) => {
  let dynamix = {
    name: "dynamix",
    garmentName: "Hose Dynamix",
    extraOptions: [],
    lightContrast: "",
    darkContrast: "",
    stitching: "",
    patchColor: "",
    azomo: "",
    price: PRICE.dynamix,
    quantity: 0,
    totalPrice: 0,
    hasPatch: true,
    hasContrast: true,
  };

  let colors = [...item[1]];

  if (colors.length < 5) {
    return "Bad url!";
  }

  colors = convertToColors(colors);

  dynamix.lightContrast = colors[0];
  dynamix.darkContrast = colors[1];
  dynamix.stitching = colors[2];
  dynamix.patchColor = colors[3];
  dynamix.azomo = colors[4];

  const optionsList = [...item[2]];
  dynamix.extraOptions = convertToOptions(optionsList);

  dynamix.extraOptions.map((i) => {
    switch (i) {
      case "Rechte Multifunktionstasche":
        return (dynamix.price = dynamix.price + PRICE.multipocket);
      case "Leuchtstreifen an den Beinen":
        return (dynamix.price = dynamix.price + PRICE.reflectivestrips);
      case "Stickerei auf Beintasche links":
        return (dynamix.price = dynamix.price + PRICE.logo);
      case "Stickerei auf Geässtsache links":
        return (dynamix.price = dynamix.price + PRICE.logo);
      case "Material: Mischgewebe":
        return (dynamix.price = dynamix.price + PRICE.mischgewebe);
      case "Material: Baumwolle verstärkt":
        return (dynamix.price = dynamix.price + PRICE.baumwolle);

      default:
        return null;
    }
  });

  if (
    dynamix.patchColor === COLORS.blackProtective.value ||
    dynamix.patchColor === COLORS.whiteProtective.value ||
    dynamix.patchColor === COLORS.grayProtective.value
  ) {
    dynamix.price += PRICE.cordura;
  }

  dynamix.quantity = parseInt(item[3]);
  dynamix.totalPrice = parseInt(item[3]) * dynamix.price;

  return dynamix;
};

const convertToParkaPrimoAussenjacke = (item) => {
  let obj = {
    name: "parkaprimoaussenjacke",
    garmentName: "Parka Primo Aussenjacke",
    extraOptions: [],
    lightContrast: "",
    darkContrast: "",
    stitching: "",
    patchColor: "",
    azomo: "",
    price: PRICE.parkaprimoaussenjacke,
    quantity: 0,
    totalPrice: 0,
    hasPatch: false,
    hasContrast: true,
  };

  let colors = [...item[1]];

  if (colors.length < 5) {
    return "Bad url!";
  }

  colors = convertToColors(colors);
  obj.lightContrast = colors[0];
  obj.darkContrast = colors[1];
  obj.stitching = colors[2];
  obj.patchColor = colors[3];
  obj.azomo = colors[4];

  const optionsList = [...item[2]];
  obj.extraOptions = convertToOptions(optionsList);

  obj.extraOptions.map((i) => {
    switch (i) {
      case "Logo auf der Rückseite":
        return (obj.price = obj.price + PRICE.logo);
      case "Logo auf der Vorderseite":
        return (obj.price = obj.price + PRICE.logo);
      case "Material: Sotina Plus":
        return (obj.price = obj.price + PRICE.sotinaplus);
      case "Material: Sotina":
        return (obj.price = obj.price + PRICE.sotina);

      default:
        return null;
    }
  });

  obj.quantity = parseInt(item[3]);
  obj.totalPrice = parseInt(item[3]) * obj.price;

  return obj;
};

const convertToParkaPrimoInnenjacke = (item) => {
  let obj = {
    name: "parkaprimoinnenjacke",
    garmentName: "Parka Primo Innenjacke",
    extraOptions: [],
    lightContrast: "",
    darkContrast: "",
    stitching: "",
    patchColor: "",
    azomo: "",
    price: PRICE.parkaprimoinnenjacke,
    quantity: 0,
    totalPrice: 0,
    hasPatch: false,
    hasContrast: true,
  };

  let colors = [...item[1]];

  if (colors.length < 5) {
    return "Bad url!";
  }

  colors = convertToColors(colors);
  obj.lightContrast = colors[0];
  obj.darkContrast = colors[1];
  obj.stitching = colors[2];
  obj.patchColor = colors[3];
  obj.azomo = colors[4];

  const optionsList = [...item[2]];
  obj.extraOptions = convertToOptions(optionsList);

  obj.extraOptions.map((i) => {
    switch (i) {
      case "Logo auf der Rückseite":
        return (obj.price = obj.price + PRICE.logo);
      case "Logo auf der Vorderseite":
        return (obj.price = obj.price + PRICE.logo);
      case "Material: Sotina Plus":
        return (obj.price = obj.price + PRICE.sotinaplus);
      case "Material: Sotina":
        return (obj.price = obj.price + PRICE.sotina);

      default:
        return null;
    }
  });

  obj.quantity = parseInt(item[3]);
  obj.totalPrice = parseInt(item[3]) * obj.price;

  return obj;
};

const convertToTrend = (item) => {
  let trend = {
    name: "trend",
    garmentName: "Hose Trend",
    extraOptions: [],
    lightContrast: "",
    darkContrast: "",
    stitching: "",
    patchColor: "",
    azomo: "",
    price: PRICE.trend,
    quantity: 0,
    totalPrice: 0,
    hasPatch: true,
    hasContrast: true,
  };

  let colors = [...item[1]];

  if (colors.length < 5) {
    return "Bad url!";
  }

  colors = convertToColors(colors);
  trend.lightContrast = colors[0];
  trend.darkContrast = colors[1];
  trend.stitching = colors[2];
  trend.patchColor = colors[3];
  trend.azomo = colors[4];

  const optionsList = [...item[2]];
  trend.extraOptions = convertToOptions(optionsList);

  trend.extraOptions.map((i) => {
    switch (i) {
      case "Rechte Multifunktionstasche":
        return (trend.price = trend.price + PRICE.multipocket);
      case "Leuchtstreifen an den Beinen":
        return (trend.price = trend.price + PRICE.reflectivestrips);
      case "Stickerei auf Beintasche links":
        return (trend.price = trend.price + PRICE.logo);
      case "Stickerei auf Geässtsache links":
        return (trend.price = trend.price + PRICE.logo);
      case "Material: Mischgewebe":
        return (trend.price = trend.price + PRICE.mischgewebe);
      case "Material: Baumwolle verstärkt":
        return (trend.price = trend.price + PRICE.baumwolle);

      default:
        return null;
    }
  });

  if (
    trend.patchColor === COLORS.blackProtective.value ||
    trend.patchColor === COLORS.whiteProtective.value ||
    trend.patchColor === COLORS.grayProtective.value
  ) {
    trend.price += PRICE.cordura;
  }

  trend.quantity = parseInt(item[3]);
  trend.totalPrice = parseInt(item[3]) * trend.price;

  return trend;
};

const convertToOpticaHose = (item) => {
  let obj = {
    name: "optica",
    garmentName: "Hose Optica",
    extraOptions: [],
    lightContrast: "",
    darkContrast: "",
    stitching: "",
    patchColor: "",
    azomo: "",
    price: PRICE.opticahose,
    quantity: 0,
    totalPrice: 0,
    hasPatch: false,
    hasContrast: true,
  };

  let colors = [...item[1]];

  if (colors.length < 5) {
    return "Bad url!";
  }

  colors = convertToColors(colors);
  obj.lightContrast = colors[0];
  obj.darkContrast = colors[1];
  obj.stitching = colors[2];
  obj.patchColor = colors[3];
  obj.azomo = colors[4];

  const optionsList = [...item[2]];
  obj.extraOptions = convertToOptions(optionsList);

  obj.extraOptions.map((i) => {
    switch (i) {
      case "Rechte Multifunktionstasche":
        return (obj.price = obj.price + PRICE.multipocket);
      case "Leuchtstreifen an den Beinen":
        return (obj.price = obj.price + PRICE.reflectivestrips);
      case "Stickerei auf Beintasche links":
        return (obj.price = obj.price + PRICE.logo);
      case "Stickerei auf Geässtsache links":
        return (obj.price = obj.price + PRICE.logo);
      case "Material: Mischgewebe":
        return (obj.price = obj.price + PRICE.mischgewebe);
      case "Material: Baumwolle verstärkt":
        return (obj.price = obj.price + PRICE.baumwolle);

      default:
        return null;
    }
  });

  obj.quantity = parseInt(item[3]);
  obj.totalPrice = parseInt(item[3]) * obj.price;

  return obj;
};

const convertToDamenkasackPrimo = (item) => {
  let obj = {
    name: "damenkasack",
    garmentName: "Damenkasack Primo",
    extraOptions: [],
    lightContrast: "",
    darkContrast: "",
    stitching: "",
    patchColor: "",
    azomo: "",
    price: PRICE.damenasackprimo,
    quantity: 0,
    totalPrice: 0,
    hasPatch: false,
    hasContrast: true,
  };

  let colors = [...item[1]];

  if (colors.length < 5) {
    return "Bad url!";
  }

  colors = convertToColors(colors);
  obj.lightContrast = colors[0];
  obj.darkContrast = colors[1];
  obj.stitching = colors[2];
  obj.patchColor = colors[3];
  obj.azomo = colors[4];

  const optionsList = [...item[2]];
  obj.extraOptions = convertToOptions(optionsList);

  obj.extraOptions.map((i) => {
    switch (i) {
      case "Logo auf der Rückseite":
        return (obj.price = obj.price + PRICE.logo);
      case "Logo auf der Vorderseite":
        return (obj.price = obj.price + PRICE.logo);
      case "Material: Mischgewebe":
        return (obj.price = obj.price + PRICE.mischgewebe);
      case "Material: Baumwolle verstärkt":
        return (obj.price = obj.price + PRICE.baumwolle);

      default:
        return null;
    }
  });

  obj.quantity = parseInt(item[3]);
  obj.totalPrice = parseInt(item[3]) * obj.price;

  return obj;
};

const convertToClassicoShorts = (item) => {
  let obj = {
    name: "classicoshorts",
    garmentName: "Shorts Classico",
    extraOptions: [],
    lightContrast: "",
    darkContrast: "",
    stitching: "",
    patchColor: "",
    azomo: "",
    price: PRICE.classicoshorts,
    quantity: 0,
    totalPrice: 0,
    hasPatch: false,
    hasContrast: true,
  };

  let colors = [...item[1]];

  if (colors.length < 5) {
    return "Bad url!";
  }

  colors = convertToColors(colors);
  obj.lightContrast = colors[0];
  obj.darkContrast = colors[1];
  obj.stitching = colors[2];
  obj.patchColor = colors[3];
  obj.azomo = colors[4];

  const optionsList = [...item[2]];
  obj.extraOptions = convertToOptions(optionsList);

  obj.extraOptions.map((i) => {
    switch (i) {
      case "Stickerei auf Beintasche links":
        return (obj.price = obj.price + PRICE.logo);
      case "Stickerei auf Geässtsache links":
        return (obj.price = obj.price + PRICE.logo);
      case "Material: Mischgewebe":
        return (obj.price = obj.price + PRICE.mischgewebe);
      case "Material: Baumwolle verstärkt":
        return (obj.price = obj.price + PRICE.baumwolle);

      default:
        return null;
    }
  });

  obj.quantity = parseInt(item[3]);
  obj.totalPrice = parseInt(item[3]) * obj.price;

  return obj;
};

const convertToGiletPrimoRV = (item) => {
  let obj = {
    name: "giletprimorv",
    garmentName: "Gilet Primo mit RV",
    extraOptions: [],
    lightContrast: "",
    darkContrast: "",
    stitching: "",
    patchColor: "",
    azomo: "",
    price: PRICE.giletprimorv,
    quantity: 0,
    totalPrice: 0,
    hasPatch: false,
    hasContrast: true,
  };

  let colors = [...item[1]];

  if (colors.length < 5) {
    return "Bad url!";
  }

  colors = convertToColors(colors);
  obj.lightContrast = colors[0];
  obj.darkContrast = colors[1];
  obj.stitching = colors[2];
  obj.patchColor = colors[3];
  obj.azomo = colors[4];

  const optionsList = [...item[2]];
  obj.extraOptions = convertToOptions(optionsList);

  obj.extraOptions.map((i) => {
    switch (i) {
      case "Logo auf der Rückseite":
        return (obj.price = obj.price + PRICE.logo);
      case "Logo auf der Vorderseite":
        return (obj.price = obj.price + PRICE.logo);
      case "Material: Mischgewebe":
        return (obj.price = obj.price + PRICE.mischgewebe);
      case "Material: Baumwolle verstärkt":
        return (obj.price = obj.price + PRICE.baumwolle);

      default:
        return null;
    }
  });

  obj.quantity = parseInt(item[3]);
  obj.totalPrice = parseInt(item[3]) * obj.price;

  return obj;
};

const convertToPolar = (item) => {
  let obj = {
    name: "polar",
    garmentName: "Fleecejacke Polar",
    extraOptions: [],
    lightContrast: "",
    darkContrast: "",
    stitching: "",
    patchColor: "",
    azomo: "",
    price: PRICE.polar,
    quantity: 0,
    totalPrice: 0,
    hasPatch: false,
    hasContrast: true,
  };

  let colors = [...item[1]];

  if (colors.length < 5) {
    return "Bad url!";
  }

  colors = convertToColors(colors);
  obj.lightContrast = colors[0];
  obj.darkContrast = colors[1];
  obj.stitching = colors[2];
  obj.patchColor = colors[3];
  obj.azomo = colors[4];

  const optionsList = [...item[2]];
  obj.extraOptions = convertToOptions(optionsList);

  obj.extraOptions.map((i) => {
    switch (i) {
      case "Logo auf der Rückseite":
        return (obj.price = obj.price + PRICE.logo);
      case "Logo auf der Vorderseite":
        return (obj.price = obj.price + PRICE.logo);
      case "Material: Polar Fleece 230":
        return (obj.price = obj.price + PRICE.fleecepolar230);
      case "Material: Polar Fleece 280":
        return (obj.price = obj.price + PRICE.fleecepolar280);

      default:
        return null;
    }
  });

  obj.quantity = parseInt(item[3]);
  obj.totalPrice = parseInt(item[3]) * obj.price;

  return obj;
};

const convertToGilletPrimoKnopfen = (item) => {
  let obj = {
    name: "gilletprimoknopfen",
    garmentName: "Gilet Primo mit Knopfen",
    extraOptions: [],
    lightContrast: "",
    darkContrast: "",
    stitching: "",
    patchColor: "",
    azomo: "",
    price: PRICE.gilletprimoknopfen,
    quantity: 0,
    totalPrice: 0,
    hasPatch: false,
    hasContrast: true,
  };

  let colors = [...item[1]];

  if (colors.length < 5) {
    return "Bad url!";
  }

  colors = convertToColors(colors);
  obj.lightContrast = colors[0];
  obj.darkContrast = colors[1];
  obj.stitching = colors[2];
  obj.patchColor = colors[3];
  obj.azomo = colors[4];

  const optionsList = [...item[2]];
  obj.extraOptions = convertToOptions(optionsList);

  obj.extraOptions.map((i) => {
    switch (i) {
      case "Logo auf der Rückseite":
        return (obj.price = obj.price + PRICE.logo);
      case "Logo auf der Vorderseite":
        return (obj.price = obj.price + PRICE.logo);
      case "Material: Mischgewebe":
        return (obj.price = obj.price + PRICE.mischgewebe);
      case "Material: Baumwolle verstärkt":
        return (obj.price = obj.price + PRICE.baumwolle);

      default:
        return null;
    }
  });

  obj.quantity = parseInt(item[3]);
  obj.totalPrice = parseInt(item[3]) * obj.price;

  return obj;
};

const convertToSoftshelljackePlus = (item) => {
  let obj = {
    name: "softshelljackeprimoplus",
    garmentName: "Softshelljacke Primo Plus",
    extraOptions: [],
    lightContrast: "",
    darkContrast: "",
    stitching: "",
    patchColor: "",
    azomo: "",
    price: PRICE.softshelljackeprimoplus,
    quantity: 0,
    totalPrice: 0,
    hasPatch: false,
    hasContrast: true,
  };

  let colors = [...item[1]];

  if (colors.length < 5) {
    return "Bad url!";
  }

  colors = convertToColors(colors);
  obj.lightContrast = colors[0];
  obj.darkContrast = colors[1];
  obj.stitching = colors[2];
  obj.patchColor = colors[3];
  obj.azomo = colors[4];

  const optionsList = [...item[2]];
  obj.extraOptions = convertToOptions(optionsList);

  obj.extraOptions.map((i) => {
    switch (i) {
      case "Logo auf der Rückseite":
        return (obj.price = obj.price + PRICE.logo);
      case "Logo auf der Vorderseite":
        return (obj.price = obj.price + PRICE.logo);
      case "Material: Softshell":
        return (obj.price = obj.price + PRICE.softshell);

      default:
        return null;
    }
  });

  obj.quantity = parseInt(item[3]);
  obj.totalPrice = parseInt(item[3]) * obj.price;

  return obj;
};

const convertToClassicoHose = (item) => {
  let obj = {
    name: "classicohose",
    garmentName: "Hose Classico",
    extraOptions: [],
    lightContrast: "",
    darkContrast: "",
    stitching: "",
    patchColor: "",
    azomo: "",
    price: PRICE.classicohose,
    quantity: 0,
    totalPrice: 0,
    hasPatch: false,
    hasContrast: true,
  };

  let colors = [...item[1]];

  if (colors.length < 5) {
    return "Bad url!";
  }

  colors = convertToColors(colors);
  obj.lightContrast = colors[0];
  obj.darkContrast = colors[1];
  obj.stitching = colors[2];
  obj.patchColor = colors[3];
  obj.azomo = colors[4];

  const optionsList = [...item[2]];
  obj.extraOptions = convertToOptions(optionsList);

  obj.extraOptions.map((i) => {
    switch (i) {
      case "Rechte Multifunktionstasche":
        return (obj.price = obj.price + PRICE.multipocket);
      case "Leuchtstreifen an den Beinen":
        return (obj.price = obj.price + PRICE.reflectivestrips);
      case "Stickerei auf Beintasche links":
        return (obj.price = obj.price + PRICE.logo);
      case "Stickerei auf Geässtsache links":
        return (obj.price = obj.price + PRICE.logo);
      case "Material: Mischgewebe":
        return (obj.price = obj.price + PRICE.mischgewebe);
      case "Material: Baumwolle verstärkt":
        return (obj.price = obj.price + PRICE.baumwolle);
      case "Cordura":
        return (obj.price = obj.price + PRICE.cordura);

      default:
        return null;
    }
  });

  obj.quantity = parseInt(item[3]);
  obj.totalPrice = parseInt(item[3]) * obj.price;

  return obj;
};

const convertToTrendGilet = (item) => {
  let obj = {
    name: "trendgilet",
    garmentName: "Trend Gilet",
    extraOptions: [],
    lightContrast: "",
    darkContrast: "",
    stitching: "",
    patchColor: "",
    azomo: "",
    price: PRICE.trendgilet,
    quantity: 0,
    totalPrice: 0,
    hasPatch: false,
    hasContrast: true,
  };

  let colors = [...item[1]];

  if (colors.length < 5) {
    return "Bad url!";
  }

  colors = convertToColors(colors);
  obj.lightContrast = colors[0];
  obj.darkContrast = colors[1];
  obj.stitching = colors[2];
  obj.patchColor = colors[3];
  obj.azomo = colors[4];

  const optionsList = [...item[2]];
  obj.extraOptions = convertToOptions(optionsList);

  obj.extraOptions.map((i) => {
    switch (i) {
      case "Logo auf der Rückseite":
        return (obj.price = obj.price + PRICE.logo);
      case "Brusttasche Links":
        return (obj.price = obj.price + PRICE.logo);
      case "Material: Mischgewebe":
        return (obj.price = obj.price + PRICE.mischgewebe);
      case "Material: Baumwolle verstärkt":
        return (obj.price = obj.price + PRICE.baumwolle);

      default:
        return null;
    }
  });

  obj.quantity = parseInt(item[3]);
  obj.totalPrice = parseInt(item[3]) * obj.price;

  return obj;
};

const convertToFleecejackePrimo = (item) => {
  let obj = {
    name: "fleecejackeprimo",
    garmentName: "Fleecejacke Primo",
    extraOptions: [],
    lightContrast: "",
    darkContrast: "",
    stitching: "",
    patchColor: "",
    azomo: "",
    price: 90,
    quantity: 0,
    totalPrice: 0,
    hasPatch: false,
    hasContrast: false,
  };

  let colors = [...item[1]];

  if (colors.length < 5) {
    return "Bad url!";
  }

  colors = convertToColors(colors);
  obj.lightContrast = colors[0];
  obj.darkContrast = colors[1];
  obj.stitching = colors[2];
  obj.patchColor = colors[3];
  obj.azomo = colors[4];

  const optionsList = [...item[2]];
  obj.extraOptions = convertToOptions(optionsList);

  obj.extraOptions.map((i) => {
    switch (i) {
      case "Logo auf der Rückseite":
        return (obj.price = obj.price + PRICE.logo);
      case "Logo auf der Vorderseite":
        return (obj.price = obj.price + PRICE.logo);
      case "Material: Polar Fleece 230":
        return (obj.price = obj.price + PRICE.fleecepolar230);
      case "Material: Polar Fleece 280":
        return (obj.price = obj.price + PRICE.fleecepolar280);

      default:
        return null;
    }
  });

  obj.quantity = parseInt(item[3]);
  obj.totalPrice = parseInt(item[3]) * obj.price;

  return obj;
};

const convertToClassicoJacke = (item) => {
  let obj = {
    name: "classicojacke",
    garmentName: "Classico Jacke",
    extraOptions: [],
    lightContrast: "",
    darkContrast: "",
    stitching: "",
    patchColor: "",
    azomo: "",
    price: PRICE.classicojacke,
    quantity: 0,
    totalPrice: 0,
    hasPatch: false,
    hasContrast: true,
  };

  let colors = [...item[1]];

  if (colors.length < 5) {
    return "Bad url!";
  }

  colors = convertToColors(colors);
  obj.lightContrast = colors[0];
  obj.darkContrast = colors[1];
  obj.stitching = colors[2];
  obj.patchColor = colors[3];
  obj.azomo = colors[4];

  const optionsList = [...item[2]];
  obj.extraOptions = convertToOptions(optionsList);

  obj.extraOptions.map((i) => {
    switch (i) {
      case "Brusttasche Links":
        return (obj.price = obj.price + PRICE.logo);
      case "Logo auf der Vorderseite":
        return (obj.price = obj.price + PRICE.logo);
      case "Material: Mischgewebe":
        return (obj.price = obj.price + PRICE.mischgewebe);
      case "Material: Baumwolle verstärkt":
        return (obj.price = obj.price + PRICE.baumwolle);

      default:
        return null;
    }
  });

  obj.quantity = parseInt(item[3]);
  obj.totalPrice = parseInt(item[3]) * obj.price;

  return obj;
};

const convertToSoftshelljacke = (item) => {
  let obj = {
    name: "softshelljackeprimo",
    garmentName: "Softshelljacke Primo",
    extraOptions: [],
    lightContrast: "",
    darkContrast: "",
    stitching: "",
    patchColor: "",
    azomo: "",
    price: PRICE.softshelljackeprimo,
    quantity: 0,
    totalPrice: 0,
    hasPatch: false,
    hasContrast: false,
  };

  let colors = [...item[1]];

  if (colors.length < 5) {
    return "Bad url!";
  }

  colors = convertToColors(colors);
  obj.lightContrast = colors[0];
  obj.darkContrast = colors[1];
  obj.stitching = colors[2];
  obj.patchColor = colors[3];
  obj.azomo = colors[4];

  const optionsList = [...item[2]];
  obj.extraOptions = convertToOptions(optionsList);

  obj.extraOptions.map((i) => {
    switch (i) {
      case "Logo auf der Rückseite":
        return (obj.price = obj.price + PRICE.logo);
      case "Logo auf der Vorderseite":
        return (obj.price = obj.price + PRICE.logo);
      case "Material: Softshell":
        return (obj.price = obj.price + PRICE.softshell);

      default:
        return null;
    }
  });

  obj.quantity = parseInt(item[3]);
  obj.totalPrice = parseInt(item[3]) * obj.price;

  return obj;
};

const convertToBerufsmantelPrimo = (item) => {
  let obj = {
    name: "berufsmantelprimo",
    garmentName: "Berufsmantel Primo",
    extraOptions: [],
    lightContrast: "",
    darkContrast: "",
    stitching: "",
    patchColor: "",
    azomo: "",
    price: PRICE.berufsmantelprimo,
    quantity: 0,
    totalPrice: 0,
    hasPatch: false,
    hasContrast: false,
  };

  let colors = [...item[1]];

  if (colors.length < 5) {
    return "Bad url!";
  }

  colors = convertToColors(colors);
  obj.lightContrast = colors[0];
  obj.darkContrast = colors[1];
  obj.stitching = colors[2];
  obj.patchColor = colors[3];
  obj.azomo = colors[4];

  const optionsList = [...item[2]];
  obj.extraOptions = convertToOptions(optionsList);

  obj.extraOptions.map((i) => {
    switch (i) {
      case "Brusttasche Links":
        return (obj.price = obj.price + PRICE.logo);
      case "Logo auf der Vorderseite":
        return (obj.price = obj.price + PRICE.logo);
      case "Material: Mischgewebe":
        return (obj.price = obj.price + PRICE.mischgewebe);
      case "Material: Baumwolle verstärkt":
        return (obj.price = obj.price + PRICE.baumwolle);

      default:
        return null;
    }
  });

  obj.quantity = parseInt(item[3]);
  obj.totalPrice = parseInt(item[3]) * obj.price;

  return obj;
};

const convertToLatzhosePrimo = (item) => {
  let obj = {
    name: "latzhoseprimo",
    garmentName: "Latzhose Primo",
    extraOptions: [],
    lightContrast: "",
    darkContrast: "",
    stitching: "",
    patchColor: "",
    azomo: "",
    price: PRICE.latzhoseprimo,
    quantity: 0,
    totalPrice: 0,
    hasPatch: false,
    hasContrast: true,
  };

  let colors = [...item[1]];

  if (colors.length < 5) {
    return "Bad url!";
  }

  colors = convertToColors(colors);
  obj.lightContrast = colors[0];
  obj.darkContrast = colors[1];
  obj.stitching = colors[2];
  obj.patchColor = colors[3];
  obj.azomo = colors[4];

  const optionsList = [...item[2]];
  obj.extraOptions = convertToOptions(optionsList);

  obj.extraOptions.map((i) => {
    switch (i) {
      case "Rechte Multifunktionstasche":
        return (obj.price = obj.price + PRICE.multipocket);
      case "Leuchtstreifen an den Beinen":
        return (obj.price = obj.price + PRICE.reflectivestrips);
      case "Stickerei auf Beintasche links":
        return (obj.price = obj.price + PRICE.logo);
      case "Stickerei auf Geässtsache links":
        return (obj.price = obj.price + PRICE.logo);
      case "Stickerei auf Brusttasche":
        return (obj.price = obj.price + PRICE.logo);
      case "Material: Mischgewebe":
        return (obj.price = obj.price + PRICE.mischgewebe);
      case "Material: Baumwolle verstärkt":
        return (obj.price = obj.price + PRICE.baumwolle);

      default:
        return null;
    }
  });

  obj.quantity = parseInt(item[3]);
  obj.totalPrice = parseInt(item[3]) * obj.price;

  return obj;
};

const convertToOverallPrimo = (item) => {
  let obj = {
    name: "overallprimo",
    garmentName: "Overall Primo",
    extraOptions: [],
    lightContrast: "",
    darkContrast: "",
    stitching: "",
    patchColor: "",
    azomo: "",
    price: PRICE.overallprimo,
    quantity: 0,
    totalPrice: 0,
    hasPatch: false,
    hasContrast: true,
  };

  let colors = [...item[1]];

  if (colors.length < 5) {
    return "Bad url!";
  }

  colors = convertToColors(colors);
  obj.lightContrast = colors[0];
  obj.darkContrast = colors[1];
  obj.stitching = colors[2];
  obj.patchColor = colors[3];
  obj.azomo = colors[4];

  const optionsList = [...item[2]];
  obj.extraOptions = convertToOptions(optionsList);

  obj.extraOptions.map((i) => {
    switch (i) {
      case "Rechte Multifunktionstasche":
        return (obj.price = obj.price + PRICE.multipocket);
      case "Leuchtstreifen an den Beinen":
        return (obj.price = obj.price + PRICE.reflectivestrips);
      case "Stickerei auf Brusttasche links":
        return (obj.price = obj.price + PRICE.logo);
      case "Stickerei auf Geässtsache links":
        return (obj.price = obj.price + PRICE.logo);
      case "Logo auf der Rückseite":
        return (obj.price = obj.price + PRICE.logo);
      case "Material: Mischgewebe":
        return (obj.price = obj.price + PRICE.mischgewebe);
      case "Material: Baumwolle verstärkt":
        return (obj.price = obj.price + PRICE.baumwolle);

      default:
        return null;
    }
  });

  obj.quantity = parseInt(item[3]);
  obj.totalPrice = parseInt(item[3]) * obj.price;

  return obj;
};

const parseUrl = () => {
  const query = new URLSearchParams(window.location.search);
  const lista = query.get("selection").split(" ");
  return new Promise((res, rej) => {
    try {
      const retVal = convertToComponent(lista);
      res(retVal);
    } catch (error) {
      rej("Bad url");
    }
  });
};

export {
  renderCartItem,
  generateParam,
  renderColor,
  generateUrlForClipboard,
  convertToColors,
  convertToOptions,
  convertToUltimateTrousers,
  convertToDynamixTrousers,
  convertToParkaPrimoAussenjacke,
  convertToParkaPrimoInnenjacke,
  convertToOpticaHose,
  convertToTrend,
  convertToGilletPrimoKnopfen,
  convertToClassicoHose,
  convertToPolar,
  convertToSoftshelljackePlus,
  convertToDamenkasackPrimo,
  convertToGiletPrimoRV,
  convertToClassicoShorts,
  parseUrl,
  convertToComponent,
  convertToClassicoJacke,
  convertToTrendGilet,
  convertToFleecejackePrimo,
  convertToBerufsmantelPrimo,
  convertToSoftshelljacke,
  convertToOverallPrimo,
  convertToLatzhosePrimo,
};
